<template>
    <div class="comment" :id="comment.id">
        <v-layout row wrap v-if="commentStatus">
            <post-owner :can-edit-all-activity-feed="canEditAllActivityFeed" :post="comment" :actions="commentActions" :is-admin-page-post="isAdminPageComment"></post-owner>
            <v-flex xs12>
                <div class="comment__body" v-if="comment.body" id="txt_comment">
                    <span id="txt_comment_body" v-html="commentMessage" > </span> <span v-if="isShowCommentSeeMore" >
                    <a @click="seeMoreComment()"
                       data-qe-id="see_more_comment_link"
                       id="btn_see_more">  {{appCommonConstants.SEE_MORE}}</a> </span>
                </div>
            </v-flex>

            <v-flex xs12 class="comment__button" v-if="!isAdminPageComment">
                <v-layout row align-content-start justify-start>
                    <v-flex xs12>
                        <span id="comment_like_btn"
                              :class="['comment__button-like', canEditAllActivityFeed ? '' : 'disable_div']"
                              data-qe-id="see_more_comment_link"
                              @click="handleCommentLike">
                            <img id="img_like_comment" class="like-image" v-if="comment.userHasLiked"
                                 src="../../../assets/thumbs-up.png"/>
                            <img id="img_dislike_comment" class="like-image" v-if="!comment.userHasLiked"
                                 src="../../../assets/thumbs-down.png"/>
                            <span class="comment__label-Likes">{{communityCommonConstant.comment.LIKE}} </span>
                        </span>
                        <span class="comment__button-reply"
                              id="comment_reply_btn"
                              data-qe-id="post_comment_toggle_box_link"
                              @click="toggleReplyPostBox"
                              v-if="showReplyButton">
                            {{communityCommonConstant.post.REPLY}}
                        </span>

                        <span class="comment__likesStatement" data-qe-id="post_like_statement">{{likesForTheComment}}</span>
                    </v-flex>
                </v-layout>

            </v-flex>

            <v-layout row wrap class="comment__replaybox">
                <v-flex xs12 v-if="replyPostBoxOpen">                    
                    <add-reply :parent-id="comment.id"
                               :toggle-reply-post-box="toggleReplyPostBox"
                               :comment-count-value="comment.commentCount">
                    </add-reply>
                </v-flex>
            </v-layout>
            <!--TODO - add after API is fixed-->
            <v-flex xs12 v-if="comment.featuredComments.length">
                <reply-list :parent-post-id="comment.id" 
                            :can-edit-all-activity-feed="canEditAllActivityFeed"
                            :reply-count="comment.commentCount" 
                            :is-admin-page-feed="isAdminPageComment"
                            :inappropriate-children="comment.inappropriateChildren"
                            :reply-list="comment.featuredComments">
                </reply-list>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import PostOwner from '../PostOwner/PostOwner';
    import { storeAction } from '../../../store/storeActions.constant';
    import { mapActions } from 'vuex';
    import { communityCommonConstant, likeStatement, commentStatement, commentActions } from '../communityCommon.constant';
    import AddReply from '../AddReply/AddReply';
    import CommentList from './CommentList';
    import AddPost from '../AddPost/AddPost';
    import ReplyList from '../Reply/ReplyList';
    import { appCommonConstants } from "../../appCommon.constants";
    import { trackActivityPostData } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: 'Comment',
        components: {
            ReplyList,
            AddPost,
            CommentList,
            AddReply,
            PostOwner,
        },
        data: () => ({
            communityCommonConstant,
            appCommonConstants,
            commentActions,
            replyPostBoxOpen: false,
            isShowCommentSeeMore: false,
        }),
        props: {
            comment: {
                type: Object,
                required: true,
            },
            canEditAllActivityFeed: {
                type: Boolean,
                default: true,
            },
            canReply: {
                type: Boolean,
                default: true,
            },
            isAdminPageComment: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            if (this.$route.query.isReplyOpen && this.$route.query.isReplyOpen === this.communityCommonConstant.TRUE && this.$route.query.commentId && this.$route.query.commentId === this.comment.id) {
                this.replyPostBoxOpen = true;
            }
        },
        methods: {
            ...mapActions({
                sendLike: `chapter/${storeAction.sendLike}`,
                sendUnlike: `chapter/${storeAction.sendUnlike}`,
                hideComment: `chapter/${storeAction.hideComment}`,
                getCommentedUsersList: `chapter/${storeAction.getCommentedUsers}`,
            }),
            handleCommentLike() {
                if (this.comment.userHasLiked) {
                    this.sendUnlike(this.comment.id);
                    return true;
                }
                if (!this.comment.userHasLiked) {
                    this.sendLike(this.comment.id);
                  trackActivityPostData(gtmEventName.C_Post_Like, this.comment);
                  return true;
                }
            },
            toggleReplyPostBox() {
                this.replyPostBoxOpen = !this.replyPostBoxOpen;
            },
            hideComments() {
                this.getCommentedUsersList(this.postId);
                this.hideComment(this.comment.id);
            },

            postActivityComment() {
                const dots = "...";   
                this.commentMessage = this.comment.body;          
                if (this.comment.body.length > 100) {
                    this.commentMessage = this.comment.body.substring(0, 100) + dots;
                    this.isShowCommentSeeMore = true;
                }
                this.commentMessage = this.commentMessage.replace(/↵/g, '\n').replace(/\n/g, "<br/>");
            },           
            seeMoreComment() {
                this.commentMessage = this.comment.body.replace(/↵/g, '\n').replace(/\n/g, "<br/>");
                this.isShowCommentSeeMore = false;
            },
        },
        computed: {
            likesForTheComment() {
                return likeStatement(this.comment);
            },
            commentForThePost() {
                return commentStatement(this.activity);
            },
            showReplyButton() {
                return this.canReply && this.comment && this.comment.canComment && !this.replyPostBoxOpen;
            },
            commentStatus() {
                return (!this.isAdminPageComment && !this.comment.hasBeenMarkedInappropriate) || 
                    (this.isAdminPageComment && (this.comment.hasBeenMarkedInappropriate || this.comment.inappropriateChildren > 0));
            },
        },
        created() {    
            this.postActivityComment();
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .comment {
        .disable_div {
            pointer-events: none;
            opacity: 0.5;
        }
        padding: 10px 5px;
        margin: 0px 0 0 25px;

        &__body {
            font-size: 12px;
            color: $black;
            margin: 5px 0 10px 78px;
            word-break: break-word;
        }

        &__likesStatement {
            margin-left: 50px;
            color: $ypo_blue;
            font-size: 12px;

            @include breakpoint(xs) {
                display: block;
                margin: 10px 0px 0 0;
            }
        }

        &__button {
            color: $ypo-cta;
            font-size: 12px;
            padding: 5px 20px;
            margin-left: 63px;

            &-like {
                margin-right: 20px;
                font-weight: 500;
                cursor: pointer;
                max-width: 50px;
                color: rgba($black, 0.8);

                &:hover {
                    color: $ypo_blue;
                }
            }

            &-reply {
                cursor: pointer;
                max-width: 50px;
                font-weight: 500;
                padding-top: 3px;
                color: rgba($black, 0.8);

                &:hover {
                    color: $ypo_blue;
                }
            }
        }

        &__replaybox {
            margin: 10px;
        }

        &__label-Likes {
            padding-left: 3px;
        }
    }

    .owner__chapter {
        font-size: 12px;
    }

    .like-image {
        margin-bottom: -1px;
    }
</style>
